// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1018": "1406adae","3261": "0d0d4eb3","5316": "67a4b63a","6469": "6adb9f1f","8637": "228f5245",}[chunkId] + ".css"
}